<template>

<div>
  <div class="header-container pb-2">
    <h2>Gestión de Proyectos</h2>
    <form @submit.prevent="filter" class="filter-form">
      <div class="form-group">
        <label>Identificador
          <b-form-input v-model="filters.codeId"/>
        </label>
      </div>
      <div class="form-group" style="flex: 0 0 300px;">
        <model-select v-model="selectedClient" :model-request="loadClients" label="Cliente" model-label="name" placeholder="Seleccionar Cliente"/>
      </div>
      <div class="form-group">
        <label>Estado
          <b-form-select v-model="filters.status" :options="statusOptions"/>
        </label>
      </div>
      <div>
        <b-button type="submit" variant="primary">Buscar</b-button>
      </div>
    </form>
    <div class="d-flex justify-content-center">
      <b-pagination class="ml-auto" v-model.number="paginator.page" @change="onPageChange"
                    :per-page="paginator.perPage" :total-rows="paginator.totalElements"/>
      <div class="pr-4 ml-auto">
        <b-button :disabled="!canCreate" v-b-modal.addProjectModal variant="success">Nuevo Proyecto</b-button>
      </div>
    </div>
  </div>
  <div class="fixed-table-container">
    <b-table striped :items="paginator.content" :fields="fields" no-local-sorting @sort-changed="sortUsers">
      <template slot="buttons" slot-scope="data">
        <b-button :disabled="!canUpdate" @click="$refs.editModal.show(data.item)" variant="primary" size="sm"><fa-icon icon="edit"/></b-button>
        <b-button :disabled="!canDelete" @click="deleteProyecto(data.item)" variant="danger" size="sm"><fa-icon icon="trash-alt"/></b-button>
      </template>
    </b-table>
  </div>
  <add-project-modal modal-id="addProjectModal" @save="create"/>
  <edit-project-modal ref="editModal" @save="update"/>
  <b-modal ref="deleteDialog" title="¿Está Seguro?" ok-title="Eliminar" cancel-title="Cancelar"
           ok-variant="danger" header-bg-variant="danger" header-text-variant="light">
    <p>¿Está seguro de que desea eliminar el proyecto?</p>
  </b-modal>
</div>

</template>

<script>

import api from '@/api/api'
import AddProjectModal from './AddProjectModal'
import EditProjectModal from './EditProjectModal'
import ModelSelect from '@/components/common/ModelSelect'
import {session} from '@/auth'

export default {
  name: 'ProjectIndex',
  components: {
    AddProjectModal,
    EditProjectModal,
    ModelSelect
  },
  created() {
    this.load(1)
  },
  data() {
    return {
      session,
      paginator: {
        page: 1,
        perPage: 10,
        totalElements: 0,
        content: []
      },
      sort: null,
      fields: [
        {key: 'codeId', label: 'Identificador', sortable: true},
        {key: 'year', label: 'Año', sortable: true},
        {key: 'client.name', label: 'Cliente', sortable: true, formatter: (v, k, item) => item.clientDTO.name},
        {key: 'title', label: 'Titulo', sortable: true},
        {key: 'managers', label: 'Responsables', formatter: managers => managers.map(m => m.name).join(', ')},
        {key: 'status', label: 'Estado', sortable: true, formatter: v => this.getStatusLabel(v)},
        {key: 'buttons', label: 'Gestión'}
      ],
      filters: {
        codeId: null,
        status: null
      },
      selectedClient: null,
      statusOptions: [
        {text: 'Todos', value: null},
        {text: 'Activado', value: 'ACTIVATED'},
        {text: 'Desactivado', value: 'DEACTIVATED'}
      ]
    }
  },
  methods: {
    loadClients(name = null) {
      return api.client.index({name, size: 50, sort: 'name'}).then(paginator => paginator.content)
    },
    getStatusLabel(value) {
      return this.statusOptions.find(i => i.value === value).text || null
    },
    onPageChange(page) {
      this.load(page)
    },
    filter() {
      this.load(1)
    },
    sortUsers(context) {
      this.sort = context.sortBy && context.sortBy + ',' + (context.sortDesc ? 'desc' : 'asc')
      this.load(1)
    },
    load(page = this.paginator.page) {
      api.project.index({page: page - 1, sort: this.sort, ...this.params}).then(paginator => {
        this.paginator.content = paginator.content
        this.paginator.totalElements = paginator.totalElements
        this.paginator.page = page
      })
    },
    create(project) {
      api.project.create(project).then(() => {
        this.load(1)
        this.$toastr('success', 'Proyecto Creado')
      })
    },
    update(project) {
      api.project.update(project).then(() => {
        this.load()
        this.$toastr('success', 'Proyecto Editado')
      })
    },
    deleteProyecto(proyecto) {
      this.$refs.deleteDialog.$off('ok') // very important. clear previous custom event listeners
      this.$refs.deleteDialog.$once('ok', () => {
        api.project.delete(proyecto.id).then(() => {
          this.load().then(() => this.$toastr('success', 'Proyecto Eliminado'))
        })
      })
      this.$refs.deleteDialog.show()
    }
  },
  computed: {
    params() {
      return {
        ...this.filters,
        size: this.paginator.perPage,
        clientId: this.selectedClient && this.selectedClient.id
      }
    },
    canCreate() {
      return this.session.authorities.includes('ROLE_PROJECT_CREATE')
    },
    canUpdate() {
      return this.session.authorities.includes('ROLE_PROJECT_UPDATE')
    },
    canDelete() {
      return this.session.authorities.includes('ROLE_PROJECT_DELETE')
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/project/Index.vue